// Минимальный фронтовый реестр коннекторов: slug → { title }.
// title нужен для back-кнопок и заголовка логов. Метаданные коннекторов
// (name, description) по-прежнему приходят из API в галерее — здесь не дублируем.
export const CONNECTORS = {
  bitrix24: { slug: 'bitrix24', title: 'Bitrix24' },
  amocrm: { slug: 'amocrm', title: 'amoCRM' }
}
